import { useTranslation } from '@frontend/i18n';
import { JustifiTokenizePaymentMethod } from '@frontend/payments-justifi-wrapper';
import { classNames } from '@frontend/string';
import { ContentLoader, Heading, TextField } from '@frontend/design-system';
import { CardOnFileJustifiContextValue } from '../../../widgets/card-on-file/context/card-on-file-justifi.context';

export type CardOnFileFormJustifiProps = {
  className?: string;
  shouldShowLoading: boolean;
  nameFieldProps: CardOnFileJustifiContextValue['nameFieldProps'];
  justifiProps: CardOnFileJustifiContextValue['justifiProps'];
  elementRef: CardOnFileJustifiContextValue['elementRef'];
};

export const CardOnFileFormJustifi = ({
  className,
  shouldShowLoading,
  nameFieldProps,
  justifiProps,
  elementRef,
}: CardOnFileFormJustifiProps) => {
  const { t } = useTranslation('payments');

  return (
    <div className={classNames('card-on-file', className)}>
      <ContentLoader show={shouldShowLoading} />
      <Heading className='add-card-form__header' level={2}>
        {t('Save Card on File')}
      </Heading>
      <TextField name='cardholderName' label={t('Cardholder Name')} hasNonFloatingLabel {...nameFieldProps} />
      <JustifiTokenizePaymentMethod elementRef={elementRef} {...justifiProps} />
    </div>
  );
};
